import { Layout } from "antd"
import { Header } from "antd/es/layout/layout"
import { ArabicLogoInDroidArabicKufi } from "components/svg"
import cx from "clsx"
import { Button, Flex, Group, Icon, Image, Text, Title } from "components/common"
import Container from "components/common/container/contianer"
import { ArabicLogo, EnglishLogo, IconLanguageSwitcher } from "components/svg"
import { FAQ_PATH } from "constants/app-paths"
import { getAppLanguage, useLanguage } from "hooks/useLanguage"
import { useMobile } from "hooks/useMobile"
import { useRef } from "react"
import { useTranslation } from "react-i18next"
import { Link, useNavigate } from "react-router-dom"
import DownloadPopUp from "./components/downloadPopUp"
import MobileHeader from "./components/mobileHeader"
import styles from "./index.module.less"

const { Content, Footer } = Layout

function AppHeader({ onClickMenuItem, locale, isLoggedIn }) {
  const { changeAppLanguage } = useLanguage()
  const { isCurrentLanguageEnglish } = useLanguage()
  const { label = "EN", key = "en" } = getAppLanguage()
  const { t } = useTranslation()
  let invertedLabel = key === "en" ? "AR" : "EN"
  const downloadRef = useRef()
  const { isMobile } = useMobile()

  const handleLanguageChange = () => {
    const newLang = key === "en" ? "ar" : "en"
    changeAppLanguage(newLang)
  }

  return isMobile ? (
    <MobileHeader />
  ) : (
    <Header className={styles.bayutHeader}>
      <div className={("breakout", styles.navbar)}>
        <Container>
          <Flex gap="23px" className={styles.headerLink}>
            <Button
              type="link"
              icon={invertedLabel === "AR" ? null : "IconLanguageSwitcher"}
              iconProps={{
                size: 20,
              }}
              text={t(invertedLabel)}
              onClick={handleLanguageChange}
            >
              {invertedLabel === "AR" && (
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <IconLanguageSwitcher size={20} />
                  <ArabicLogoInDroidArabicKufi width={35} height={20} style={{ marginBottom: 0 }} />
                </div>
              )}
            </Button>
            <Button
              onClick={() => {
                downloadRef?.current?.setVisible(true)
              }}
              type="link"
              icon="IconsmartPhone"
              text={t("Download App")}
            />
          </Flex>
        </Container>
      </div>
      <div className={"breakout"} style={{ background: "#fff" }}>
        <Container>
          <Flex align="center" justify="space-between" style={{ paddingBlock: "7px" }}>
            {/* {true && (
              <Icon
                onClick={() => {
                  MobileNavbarRef?.current?.setVisible(true)
                }}
                color={"black"}
                style={{ margin: 20 }}
                icon={"IoMdMenu"}
              />
            )} */}
            <Link to={"/"} style={{ lineHeight: "normal" }}>
              {isCurrentLanguageEnglish ? (
                <EnglishLogo width={92} height={46} />
              ) : (
                <ArabicLogo width={92} height={46} />
              )}
            </Link>
            <div className={cx("d-flex flexYcenter", styles.pageHeaderLinks)} style={{ gap: "22px" }}>
              <Link to={"/"}>{t("Home")}</Link>

              <Link to={"/about-us"}>{t("About Us")}</Link>

              <Link to={"/contact-us"}>{t("Contact Us")}</Link>

              <Link to={FAQ_PATH}>{t("faqs_title")}</Link>

              <Button
                onClick={() => {
                  downloadRef?.current?.setVisible(true)
                }}
                style={{ fontSize: "16px" }}
                size="small"
                type="secondary-filled"
                text={t("Download App")}
              />
            </div>
          </Flex>
        </Container>
      </div>
      <DownloadPopUp ref={downloadRef} />
    </Header>
  )
}

export default AppHeader
